import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { EnterpriseService } from "../enterprise.service";

@Component({
  selector: "app-enterprises",
  templateUrl: "./enterprises.component.html",
  styleUrls: ["./enterprises.component.sass"],
})
export class EnterprisesComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private enterpriseService: EnterpriseService,
    private router: Router,
  ) {}

  trips: any[] = [];
  page = 1;
  limit = 6;
  enterpriseList = [];
  totalPages = 0;
  totalRecords = 0;
  search = "";

  ngOnInit(): void {
    this.getEnterprises();
  }

  getEnterprises() {
    this.spinner.show();
    const params = {
      page: this.page,
      limit: this.limit,
      search: this.search,
    };

    this.enterpriseService.getEnterpriseList(params).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode === 200) {
        this.enterpriseList = res.data.data;
        this.totalRecords = res.data.pagination.total;
      } else {
        this.toastr.error(res.message);
      }
    });
  }

  gty(page) {
    this.page = page;
    this.getEnterprises();
  }

  onSearch() {
    this.page = 1;
    this.getEnterprises();
  }

  viewDashboard(enterprise: any) {
  this.router.navigate(
    ["dashboard/enterprise-dashboard"],
    { queryParams: { id: enterprise._id } }
  );
}

}
